import { useMutation, useQueryClient } from "@tanstack/react-query";
import creativeStudioApiClient, {
  CreateCreativeJobRequest,
} from "../creativeStudio";
import { CREATIVE_JOBS_QUERY_KEY } from "./useCreativeJobsQuery";

const useCreateCreativeJobMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["create-creative-job"],
    mutationFn: (request: CreateCreativeJobRequest) =>
      creativeStudioApiClient.createJob(request),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: CREATIVE_JOBS_QUERY_KEY }),
  });
};

export default useCreateCreativeJobMutation;
